/* Built In Imports */
import { usePathname } from 'next/navigation';
import { useRef, useState } from 'react';
/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import config from '@config';
import {
  RemarketDrawer,
  RemarketModal,
} from '@ieo/Components/Modal/RemarketModal';

/* Configs */
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';
import { useMediaQuery } from 'react-responsive';

/* Styles */

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {string} region
 * @param {string} lang
 * @returns {ReactElement} component
 */
const RemrktIsProgramForMe = ({ sectionContent, region, lang }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isModal = useMediaQuery({ maxWidth: 769 });
  const [modalData, setModalData] = useState(null);
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const [ind, setIndex] = useState(-1);
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const btnRef = useRef(null);
  const isMobile = useBreakpointValue({ base: true, md: false });
  function findField(fieldId) {
    const data = sectionContent.find(el => el.fieldId === fieldId);
    return data;
  }

  const pathname = usePathname();

  return (
    <Box
      w="100%"
      mx="auto"
      px={{ base: '16px', sm: '0' }}
      py={{ base: '40px', md: '60px', lg: '80px' }}
      bgImg={{
        base: 'none',
        md: 'https://static.sadhguru.org/d/46272/1733516221-81185-1.png',
      }}
      bgColor="#F1EBDF"
      bgRepeat="no-repeat"
      bgPos="right -40px"
      id="programforme"
    >
      <Box
        maxW={{
          base: '100%',
          sm: 'calc(100% - 66px)',
          xl: '1120px',
          '2xl': '1120px',
        }}
        w="100%"
        ml={{ base: '0', sm: '30px', md: '50px', xl: 'auto' }}
        mr={{ base: '0', sm: 'auto', xl: 'auto' }}
      >
        <Heading
          as="h3"
          color="#12166F"
          fontFamily={ResearchShowsSt[lang]?.heading?.fontFamily}
          fontSize={{ base: '26px', lg: '34px' }}
          fontStyle="normal"
          fontWeight={'normal'}
          lineHeight={{ base: '40px', md: '27.16px', lg: '25.22px' }}
          w={{
            base: 'auto',
            md: '100%',
            xl: 'auto',
          }}
          maxW="500px"
          textAlign="center"
          mx="auto"
          position="relative"
          pt={{ base: '0px', md: '30px' }}
        >
          {sectionContent[0]?.titleText}
          <Box
            borderTop="2px solid #CBCBCB"
            mt={{ base: '20px', md: '40px' }}
          ></Box>
        </Heading>

        <Flex height="100%">
          <Flex
            justifyContent="center"
            mt={{ base: '0px', md: '10px', xl: '0' }}
            flexWrap="wrap"
            alignItems="center"
          >
            {searchByFieldId(sectionContent, 'ieo-program-text') && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(sectionContent, 'ieo-program-text').body
                )}
                region={region}
                lang={lang}
                fontSize={{ base: '18px', lg: '22px' }}
                fontFamily="'FedraSansStd-book'"
                color="#A81D28"
                textAlign="center"
                maxW="830px !important"
                pt="8px"
              />
            )}
            {searchByFieldId(sectionContent, 'learn-program-text') && (
              <StructuredTextParser
                str={render(
                  searchByFieldId(sectionContent, 'learn-program-text').body
                )}
                region={region}
                lang={lang}
                fontSize={{ base: '18px', lg: '20px' }}
                fontFamily="'FedraSansStd-book'"
                color="#3F3F3F"
                textAlign="center"
                maxW="710px !important"
                pt="8px"
                mb="60px"
              />
            )}

            <Flex
              mt={{ base: '50px', md: '43px', lg: '53px' }}
              gridRowGap={{ base: '0', sm: '100px' }}
              gridColumnGap="20px"
              flexWrap="wrap"
              maxW="1170px"
              mx="auto"
            >
              {sectionContent[3]?.cards?.map((card, index) => {
                return (
                  <Flex
                    alignItems="flex-end"
                    justifyContent="flex-end"
                    w={{ base: '100%', sm: 'auto', md: '45%', xl: '32%' }}
                    h={{ base: 'fit-content', md: '325px' }}
                    key={nanoid(4)}
                    mb={{ base: '45px', sm: '0' }}
                    onClick={() => {
                      isMobile && setIndex(index);
                      isMobile &&
                        setIsOpenMobile(
                          index === ind && isOpenMobile ? false : true
                        );
                    }}
                  >
                    <Box
                      h="100%"
                      position="relative"
                      w="100%"
                      bg="#fff"
                      display="flex"
                      justifyContent="space-between"
                      flexDir="column"
                      pt={{ base: '40px', md: '0px' }}
                    >
                      <Box
                        alignSelf={'auto'}
                        width={{ base: '60px', md: '90px' }}
                        height={{ base: '60px', md: '90px' }}
                        position="absolute"
                        top={{ base: '-30px', md: '-50px' }}
                        left={{ base: '26px', md: '20px' }}
                      >
                        <Image
                          my="0"
                          src={card?.thumbnail?.url}
                          mx="0"
                          px="0"
                          py="0"
                          w={{ base: '60px', md: '90px' }}
                          h={{ base: '60px', md: '90px' }}
                        />
                      </Box>
                      <Flex
                        w="100%"
                        borderLeft={{
                          base: '6px solid #A81D28',
                          sm: '10px solid #A81D28',
                        }}
                        h={{ base: '60%', sm: '75%' }}
                        mt={{ base: '35px', md: 'auto' }}
                        mb="0px"
                        pb="60px"
                        alignItems="center"
                        justifyContent="center"
                        fontFamily="FedraSansStd-book"
                        flexDir="column"
                        px="20px"
                      >
                        <Flex
                          w="100%"
                          justifyContent="space-between"
                          flexDir="column"
                        >
                          <Box
                            color="#11146E"
                            fontFamily="FedraSansStd-book"
                            fontSize={{ base: '22px', md: '26px' }}
                            pt={{ base: '16px', md: '30px' }}
                            lineHeight="36px"
                            fontWeight="600"
                          >
                            {card?.title}{' '}
                          </Box>
                          <StructuredTextParser
                            {...ResearchShowsSt[lang].popUpTitle}
                            mt="16px"
                            str={render(card?.description?.value)}
                            id="ResearchCardText"
                            noOfLines={{ base: 5, md: 3 }}
                            color="#000"
                            fontSize={{ base: '16px', md: '18px' }}
                            lineHeight="30px"
                          />
                          <Box
                            color="#A81D28"
                            fontFamily="FedraSansStd-book"
                            fontSize="20px"
                            pt={{ base: '16px', md: '20px' }}
                            textDecor="underline"
                          >
                            <Text
                              onClick={() => {
                                onOpen();
                                setModalData(card);
                              }}
                              cursor="pointer"
                            >
                              {card?.buttonText}
                            </Text>
                          </Box>
                        </Flex>
                      </Flex>
                    </Box>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>
        </Flex>
      </Box>

      {modalData !== null &&
        isOpen &&
        (isMobile ? (
          <RemarketDrawer
            lang={lang}
            divider={false}
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ) : (
          <RemarketModal
            divider={false}
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ))}
      <style global jsx>
        {`
          #ResearchCardText p {
            color: #423e3b;
            font-family: FedraSansStd-book;
          }
          #ResearchCardText p strong {
            color: #a81d28;
            font-family: FedraSansStd-medium;
            font-weight: normal;
          }
        `}
      </style>
    </Box>
  );
};

export default RemrktIsProgramForMe;
